<template lang="pug" >
	v-card.style-html(dark)
		v-card-title.no-padding
			v-toolbar(dark='', class='red darken-4',dense)
				v-toolbar-title.white--text {{titulo}}
				
				
		v-card-text.no-padding.style-card()
			v-container(grid-list-lg)
				v-layout(row,wrap)
					v-flex.no-padding-vertical(xs12 sm12 md12 lg12 sl12)
						p.white--text(style="font-size:20px") {{descripcion}}
					v-flex.no-padding-vertical(v-if="Array.isArray(listaDescripcion)" xs12 sm12 md12 lg12 sl12)
						p(v-for="(item, index) in listaDescripcion" style="font-size:18px;") 
							span
								v-icon(color="red darken-4") warning
							|{{index+1}}.- {{item}}
		v-divider
		v-card-actions.style-card
			v-spacer
			v-btn( class="red text-initial" style="color:#ffffff !important" @click="onNo" flat ) Aceptar				
									
</template>
<style>
.text-normal {
  text-transform: initial;
}
</style>
<script>
module.exports = {
  props: {
    onNo: {
      type: Function,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    descripcion: {
      type: String,
      required: true
    },
    listaDescripcion: {
      type: Array,
      required: false
    }
  },
  mounted: function() {
    return this.$nextTick(function() {});
  }
};
</script>


